// extracted by mini-css-extract-plugin
export default {"tableWrapper":"Table_tableWrapper__csqAX","table":"Table_table__JvUPc"};